'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechdetailsen', {
        url: '/speechdetailsen',
        template: '<speechdetailsen></speechdetailsen>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechdetailsen/speechdetailsen.routes.js